import { useEffect, useMemo, useState } from "react"
import { getElectronZoomCompensationStyle } from "@shared/utils/electronZoomCompensation"

export const ELECTRON_ZOOM_CHANGED_EVENT = "electron-zoom-changed"

interface ElectronZoomChangedDetail {
  zoomFactor?: number
}

const normalizeZoomFactor = (value?: number | null) => {
  if (!value || Number.isNaN(value) || value <= 0) {
    return 1
  }

  return value
}

export const useElectronZoomFactor = () => {
  const [zoomFactor, setZoomFactor] = useState(1)

  useEffect(() => {
    let mounted = true

    void window.electronAPI
      ?.getZoomFactor?.()
      .then(value => {
        if (!mounted || typeof value !== "number") {
          return
        }
        setZoomFactor(normalizeZoomFactor(value))
      })
      .catch(error => {
        console.error("현재 줌 배율 조회 실패:", error)
      })

    const handleZoomChanged = (event: Event) => {
      const customEvent = event as CustomEvent<ElectronZoomChangedDetail>
      setZoomFactor(normalizeZoomFactor(customEvent.detail?.zoomFactor))
    }

    window.addEventListener(ELECTRON_ZOOM_CHANGED_EVENT, handleZoomChanged)

    return () => {
      mounted = false
      window.removeEventListener(ELECTRON_ZOOM_CHANGED_EVENT, handleZoomChanged)
    }
  }, [])

  return zoomFactor
}

export const useElectronZoomCompensationStyle = () => {
  const zoomFactor = useElectronZoomFactor()

  return useMemo<React.CSSProperties>(() => getElectronZoomCompensationStyle(zoomFactor), [zoomFactor])
}
